/*
 | -------------------------------------------------------------
 |  --> type: section
 |  --> name: navigation main
 | -------------------------------------------------------------
 |
 |  Main navigation design system component functionalities.
 |
*/

/**
 * @todo refactor to use functions if possible
 * @todo prevent dropdown menu from going of canvas when on the last menu item
*/

/*
 1. add event listener to responsive menu button if it exists
 2. get section, main menu, button text and icon
 3. toggle between menu states
 4. set classes to section and main menu
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const mainMenu = document.querySelector('[data-navigation-main="menu"]')
const responsiveMenuButton = document.getElementById('responsive-menu-toggle') // get the button id

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

// click event for responsive menu toggle
responsiveMenuButton && responsiveMenuButton.addEventListener('click', () => {
  const responsiveSection = document.querySelector('[data-navigation-main="container"]') // get main nav section
  const responsiveMenu = document.querySelector('[data-navigation-main="menu"]') // get main nav menu div
  const responsiveButtonText = responsiveMenuButton.querySelector('span') // get span that contains the text
  const responsiveButtonIcon = responsiveMenuButton.querySelector('[data-icon]') // get the icon

  // toggle between menu closed and menu open states
  if (responsiveButtonText.innerHTML === 'Menu') {
    responsiveButtonText.innerHTML = 'Sluit'
    responsiveButtonIcon.outerHTML = '<i class="fas fa-times" aria-label="" aria-hidden="true"></i>'
    responsiveMenuButton.setAttribute('aria-expanded', 'true')
  } else {
    responsiveButtonText.innerHTML = 'Menu'
    responsiveButtonIcon.outerHTML = '<i class="fas fa-bars" aria-label="" aria-hidden="true"></i>'
    responsiveMenuButton.setAttribute('aria-expanded', 'false')
  }

  // add respective classes to the section and the main nav
  responsiveMenu.classList.toggle('show')
  responsiveSection.classList.toggle('responsive-menu-open')
})

mainMenu && mainMenu.addEventListener('keydown', event => {
  // √ 1. get an array of all the menu items
  // √ 2. check if the event is on a menu item, else return
  if (!event.target.closest('[data-menu-item]').querySelector('a')) return

  const currentMenuItem = event.target.closest('[data-menu-item]')
  const menuItems = [...mainMenu.querySelectorAll('[data-menu-item]')]
  const index = menuItems.findIndex(item => item === currentMenuItem)

  const key = event.key

  let targetItem

  // move right on arrow right
  if (key === 'ArrowRight') {
    // if it's the last item, go the first, else go to next
    if (menuItems.indexOf(currentMenuItem) === menuItems.length - 1) {
      targetItem = menuItems[0]
    } else {
      targetItem = menuItems[index + 1]
    }
  }

  // move left on arrow left
  if (key === 'ArrowLeft') {
    // if it's the first item, go the last, else go to next
    if (menuItems.indexOf(currentMenuItem) === 0) {
      targetItem = menuItems[menuItems.length - 1]
    } else {
      targetItem = menuItems[index - 1]
    }
  }

  // escape to go back to first item
  if (key === 'Escape') {
    if (event.target.parentNode.hasAttribute('data-menu-item')) {
      targetItem = menuItems[0]
    }
  }

  const dropdownToggle = event.target.closest('[data-dropdown="parent"]')

  // trigger dropdown menu with down arrow
  if (dropdownToggle) {
    const dropdownMenu = dropdownToggle.parentNode.querySelector('[data-dropdown="child"]')
    const dropdownMenuItem = dropdownMenu.querySelector('[data-dropdown-item]')

    if (key === 'ArrowDown') {
      event.preventDefault()

      dropdownToggle.classList.add('open')
      dropdownMenu.classList.add('show')
      targetItem = dropdownMenuItem
    }

    if (key === 'Escape') {
      dropdownToggle.classList.remove('open')
      dropdownMenu.classList.remove('show')
    }
  }

  const currentDropdownItem = event.target.closest('[data-dropdown-item]')
  // navigate inside dropdown menu items
  if (currentDropdownItem) {
    const dropdownMenu = currentDropdownItem.parentNode
    const dropdownMenuItems = [...dropdownMenu.querySelectorAll('[data-dropdown-item]')]
    const index = dropdownMenuItems.findIndex(drop => drop === currentDropdownItem)

    if (key === 'ArrowDown') {
      event.preventDefault()

      // if it's the last item, go the first, else go to next
      if (dropdownMenuItems.indexOf(currentDropdownItem) === dropdownMenuItems.length - 1) {
        targetItem = dropdownMenuItems[0]
      } else {
        targetItem = dropdownMenuItems[index + 1]
      }
    }

    if (key === 'ArrowUp') {
      event.preventDefault()

      // if it's the first item, go the last, else go to next
      if (dropdownMenuItems.indexOf(currentDropdownItem) === 0) {
        targetItem = dropdownMenuItems[dropdownMenuItems.length - 1]
      } else {
        targetItem = dropdownMenuItems[index - 1]
      }
    }

    if (key === 'Escape') {
      const dropdownToggle = dropdownMenu.parentNode.querySelector('[data-dropdown="parent"]')
      dropdownToggle.classList.remove('open')
      dropdownMenu.classList.remove('show')
      targetItem = dropdownToggle.parentNode
    }
  }

  // set focus on target item
  if (targetItem) {
    targetItem.querySelector('a, button').focus()
  }
})
